module.exports = __webpack_public_path__ + "static/img/bgmap1.92603a2d.png";